<mat-form-field [formGroup]="group" [appearance]="appearance">
  <mat-label>{{field?.localeText?.name}}</mat-label>
  <input matInput type="number" step="1"
    onkeydown="if(event.key==='.' || event.key==='e' || event.key==='E' || event.key==='-' || event.key==='+'){event.preventDefault();}"
    [placeholder]="field?.localeText.placeholder?field?.localeText.placeholder:field?.localeText.name" [type]="type" [required]="field?.required"
    [formControlName]="field?.fieldKey" [readonly]="field?.readOnly">
  <span matPrefix class="myPrefix">
    <span class="flag-dd-mobile-field" [ngClass]="{'readonly': field?.readOnly}">
      <mat-select [(value)]="selectedLanguage" (selectionChange)="addprefix($event)">
        <input class="search" placeholder="Country name" (keyup)="setSearchTerm($event)">
        <mat-select-trigger>
          <span class="flag"
            style="background: url('https://cdn.cidaas.de/images/flags/country_flags/{{selectedLanguage | lowercase}}.svg'); margin-top: 0px;"></span>
        </mat-select-trigger>
        <mat-option *ngFor="let lang of (prefixes | sort:'asc':'name' | search:searchTerm)" [value]="lang.code">
          <span class="flag"
            style="background: url('https://cdn.cidaas.de/images/flags/country_flags/{{lang.code | lowercase}}.svg');"></span>
          <span class="content">{{lang?.name}}</span>
          <span class="content">({{lang?.dial_code}})</span>
        </mat-option>
      </mat-select>
    </span>
    <span style="float: left; padding: 0 10px">{{prefix['dial_code']}}</span>
  </span>
  <mat-hint *ngIf="field?.localeText.hint">{{field?.localeText.hint}}</mat-hint>
  <ng-container *ngFor="let validation of field?.validation;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field?.fieldKey).hasError(validation.name)">
      {{validation?.message}}
    </mat-error>
  </ng-container>
</mat-form-field>
